import { render, staticRenderFns } from "./Classifications.vue?vue&type=template&id=02f48b2a&lang=pug&"
import script from "./Classifications.vue?vue&type=script&lang=js&"
export * from "./Classifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports